import React from 'react';
import { Link } from 'react-router-dom';
import { User, LogOut } from 'lucide-react';

const Navbar = ({ user, onLogout }) => {
  return (
    <nav className="navbar">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <a href="/" className="navbar-brand">
            Chatbot Admin
          </a>

          <div className="d-flex align-items-center">
            <Link
              to="/profile"
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                marginRight: '20px', textDecoration: 'none', color: 'inherit',
              }}
            >
              <User size={16} />
              <span>{user?.full_name || user?.email || 'Admin'}</span>
            </Link>

            <button
              onClick={onLogout}
              className="btn btn-secondary"
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <LogOut size={16} />
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
